import type { Item } from '../../items-shared/types';

const validateItemsUrls = (items: Item[]) => {
	items.forEach((item) => {
		if (!!item?.link && !item?.link.startsWith('http')) {
			item.link = '';
		}
	});
};

export const checkItems = (items?: Item[]) => {
	if (!items || items?.length === 0) {
		return null;
	} else if (Array.isArray(items)) {
		validateItemsUrls(items);
		return items;
	}
};
